import { createSlice } from "@reduxjs/toolkit"
import VwStkCikishareketDTO from "src/models/StokEczane/DepoDurum/VwStkCikishareketDTO";
import VwStkGirishareketDTO from "src/models/StokEczane/DepoDurum/VwStkGirishareketDTO";
import VwStkAraDTO from "src/models/StokEczane/StokDurum/VwStkAraDTO";
import VwStkDepodurumlistDTO from "src/models/StokEczane/StokDurum/VwStkDepodurumlistDTO";
import VwStkGirisegoredepostokdurumDTO from "src/models/StokEczane/StokDurum/VwStkGirisegoredepostokdurumDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads"
import { DepoDurumApi } from "src/services/StokEczane/DepoDurumApi";
import { StokDurumApi } from "src/services/StokEczane/StokDurumApi";

export class DepoDurumAramaKriterleriObject {
    depoId: number;
    mevcutOlanlariGoster: boolean;
}
export class SeciliIlac {
    id: number = 0;
    ad: string = "";
    depoDonemId: number = 0;
}

interface IDepoDurumState {
    aramaKriterleri: DepoDurumAramaKriterleriObject,
    stokDurum: Array<VwStkAraDTO>,
    activeDepoDurum: VwStkAraDTO;
    selectedIlac: SeciliIlac,
    stkGirisList: VwStkGirishareketDTO[],
    stkGirisActiveRow: VwStkGirishareketDTO;
    stkCikisList: VwStkCikishareketDTO[],
    refetch?: boolean;
    depoDurumList:Array<VwStkDepodurumlistDTO>,
    depoGirisDurumList:Array<VwStkGirisegoredepostokdurumDTO>,
}

const DepoDurumSlice = createSlice<IDepoDurumState, MapReducerPayloads<
    IDepoDurumState,
    {
        setAramaKriterleri: DepoDurumAramaKriterleriObject,
        setStokDurum: Array<VwStkAraDTO>,
        setActiveDepoDurum: VwStkAraDTO,
        setSelectedIlac: SeciliIlac,
        setStkGirisList: VwStkGirishareketDTO[],
        setStkGirisActiveRow: VwStkGirishareketDTO,
        setStkCikisList: VwStkCikishareketDTO[],
        setRefetch: boolean,
        setDepoDurumList:Array<VwStkDepodurumlistDTO>,
        setDepoGirisDurumList:Array<VwStkGirisegoredepostokdurumDTO>,
    }
>>({
    name: 'OrderTalep',
    initialState: {
        aramaKriterleri: {
            ...new DepoDurumAramaKriterleriObject(),
            depoId: 0,
            mevcutOlanlariGoster: false
        },
        stokDurum: new Array<VwStkAraDTO>(),
        activeDepoDurum: new VwStkAraDTO(),
        selectedIlac: new SeciliIlac(),
        stkGirisList: new Array<VwStkGirishareketDTO>(),
        stkGirisActiveRow: new VwStkGirishareketDTO(),
        stkCikisList: new Array<VwStkCikishareketDTO>(),
        refetch: false,
        depoDurumList:new Array<VwStkDepodurumlistDTO>(),
        depoGirisDurumList:new Array<VwStkGirisegoredepostokdurumDTO>(),
    },
    reducers: {
        setAramaKriterleri: (state, action) => {
            state.aramaKriterleri = action.payload
        },
        setStokDurum: (state, action) => {
            state.stokDurum = action.payload
        },
        setActiveDepoDurum: (state, action) => {
            state.activeDepoDurum = action.payload
        },
        setSelectedIlac: (state, action) => {
            state.selectedIlac = action.payload
        },
        setStkGirisList: (state, action) => {
            state.stkGirisList = action.payload
        },
        setStkGirisActiveRow: (state, action) => {
            state.stkGirisActiveRow = action.payload
        },
        setStkCikisList: (state, action) => {
            state.stkCikisList = action.payload
        },
        setRefetch: (state, action) => {
            state.refetch = action.payload
        },
        setDepoDurumList: (state, action) => {
            state.depoDurumList = action.payload
        },
        setDepoGirisDurumList: (state, action) => {
            state.depoGirisDurumList = action.payload
        },
    },
    extraReducers: (builder) => {
        // builder.addMatcher(StokDurumApi.endpoints.getStokDurumList.matchFulfilled, (state, action) => {
        //     state.stokDurum = action.payload.data;
        //     return state;
        // })
        builder.addMatcher(DepoDurumApi.endpoints.GetStokGiris.matchFulfilled, (state, action) => {
            state.stkGirisList = action.payload;
            return state;
        })
        builder.addMatcher(DepoDurumApi.endpoints.GetStokCikis.matchFulfilled, (state, action) => {
            state.stkCikisList = action.payload;
            return state;
        })
    }
})

export default DepoDurumSlice;